import React from 'react';
import { Customized } from 'recharts';
import { NAVY } from './palette';

const SWATCH = 14;
const GAP = 18;
const CHAR_WIDTH = 7;

/**
 * A legend drawn inside the chart's own SVG.
 *
 * Recharts' Legend renders outside the SVG, so a pattern fill defined in the
 * chart's `<defs>` is out of scope for its swatches and they come up blank,
 * and the downloaded PNG would carry no legend at all. Drawing it in the SVG
 * keeps patterns, markers, and the saved image consistent.
 *
 * `items` is a list of `{ label, swatch }`, `swatch` being an SVG element
 * drawn in a 14px box at the origin.
 */
export function svgLegend(items) {
    function Legend() {
        let x = 8;
        return (
            <g>
                {items.map((item) => {
                    const at = x;
                    x += SWATCH + 6 + item.label.length * CHAR_WIDTH + GAP;
                    return (
                        <g key={item.label} transform={`translate(${at}, 6)`}>
                            {item.swatch}
                            <text
                                x={SWATCH + 6}
                                y={SWATCH - 3}
                                fill={NAVY}
                                fontSize={12}
                            >
                                {item.label}
                            </text>
                        </g>
                    );
                })}
            </g>
        );
    }
    return <Customized key="legend" component={Legend} />;
}
